import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import i18n from 'i18next'
import styled from "styled-components";

import { apiDomain, basename } from '../setting';
import useApplyNewStore from './useApplyNewStore';
import useModalStore from './useModalStore';
import FormButtonPrimary from '../components/form/FormButtonPrimary';
import FormRemark from '../components/form/FormRemark';
import FormText from '../components/form/FormText';
import Flex from '../components/core/Flex';
import Space from '../components/core/Space';

const useAuthStore = create(
    persist(
        (set, get) => ({
            token: "",
            // idinsn: "",
            // idplno: "",
            // email: "",
            // fullname: "",
            userAuthenticate: async () => {
                const { step0_Q1, step0_Q2, step0_Q3, step0_Q4, step0_Q5, step0_Q6, step0_Q7 } = useApplyNewStore.getState();
                const { openModalInfo } = useModalStore.getState();

                const ContentNoEmail = () => {
                    return (
                        <Flex direction={"column"} gap={16}>
                            <Flex direction={"column"} alignItems={"flex-start"} style={{ maxWidth: 500 }}>
                                <FormText>{i18n.t("translation:apply.step0.popup_no_email.content1")}</FormText>
                                <FormText>{i18n.t("translation:apply.step0.popup_no_email.content2")}</FormText>
                                <FormText>{i18n.t("translation:apply.step0.popup_no_email.content3")}</FormText>
                                <Space />
                                <FormText>{i18n.t("translation:apply.step0.popup_no_email.content4")}</FormText>
                                <Flex gap={0}>
                                    <img src={`${process.env.PUBLIC_URL}/images/tray-arrow-d.png`} alt="HospitalisationPreRegistration.pdf" style={{ width: 24, height: 24 }} />
                                    <DownloadButton onClick={() => {
                                        const url = `${process.env.REACT_APP_PDF_PREFIX}/HospitalisationPreRegistration.pdf`;
                                        window.open(url, '_blank');
                                    }}><DownloadButtonText>{i18n.t("translation:apply.step0.popup_no_email.form1")}</DownloadButtonText></DownloadButton>
                                </Flex>
                                <Flex gap={0}>
                                    <img src={`${process.env.PUBLIC_URL}/images/tray-arrow-d.png`} alt="Pre-hospitalisation Claim Assessment Form.pdf" style={{ width: 24, height: 24 }} />
                                    <DownloadButton onClick={() => {
                                        const url = `${process.env.REACT_APP_PDF_PREFIX}/Pre-hospitalisation Claim Assessment Form.pdf`;
                                        window.open(url, '_blank');
                                    }}><DownloadButtonText>{i18n.t("translation:apply.step0.popup_no_email.form2")}</DownloadButtonText></DownloadButton>
                                </Flex>
                            </Flex>
                            <FormButtonPrimary onClick={() => {
                                window.open('https://supercare.bluecross.com.hk/Member/MemberDefault.aspx', '_blank');
                            }}>{i18n.t("translation:apply.step0.popup_no_email.btn")}</FormButtonPrimary>
                            <FormRemark>{i18n.t("translation:apply.step0.popup_no_email.remark")}</FormRemark>
                        </Flex >
                    );
                }

                const openNoEmailModal = () => {
                    openModalInfo({
                        title: i18n.t("translation:apply.step0.popup_no_email.title"),
                        isShowConfirmBtn: false,
                        content: <ContentNoEmail />,
                        modalInfoText: "",
                        style: { content: { width: 650 } },
                    });
                }

                const response = await fetch(`${apiDomain}/${basename}/api/general/UserAuthenticate`, {
                    method: 'POST',
                    body: JSON.stringify({
                        "PLNO": step0_Q1.trim(),
                        "STAFFID": step0_Q4 === "person" ? step0_Q5.trim() : step0_Q6.trim(),
                        "DEPENDCODE": step0_Q7.trim(),
                        "userName": step0_Q2.trim(),
                        "userDOB": step0_Q3.trim(),
                    })
                });

                if (response.status === 401) { // Unauthorized
                    throw new Error('Unauthorized Signin');
                }

                if (!response.ok) {
                    throw new Error('Network Error');
                }

                const data = await response.json();

                if (data.reason === "DOBINCORRECT") {
                    throw new Error('Unauthorized Wrong DOB');
                }

                set({
                    token: data.token
                });
                return true;
            },
            logout: () => {
                set({
                    token: "",
                    // idinsn: "",
                    // idplno: "",
                    // email: "",
                    // fullname: "",
                });
            }
        }),
        {
            name: 'auth',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
)

const DownloadButtonText = styled.div`
    font-size: 14px;
    line-height: 24px;
    color: var(--aia-bx-dark-blue);
`;

const DownloadButton = styled.button`
    border: none;
    cursor: pointer;
    text-decoration: underline;
    background-color: transparent;
    color: var(--aia-bx-dark-blue);
`;

export default useAuthStore;